import React from 'react';
import { Clock, CreditCard, TrendingDown, AlertCircle } from 'lucide-react';
const ProblemSection = () => {
  return <section id="problem" className="section bg-light-sky" data-id="element-210">
      <div className="container" data-id="element-211">
        <div className="text-center mb-16" data-id="element-212">
          <h2 className="font-outfit font-bold text-3xl md:text-4xl mb-6" data-id="element-213">
            Bill Management Shouldn't Be This Hard
          </h2>
          <p className="text-slate-grey text-lg max-w-3xl mx-auto" data-id="element-214">
            Malaysian businesses waste countless hours and resources managing
            vendor payments. Here's what we found:
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-215">
          {/* Statistic 1 */}
          <div className="card text-center" data-id="element-216">
            <div className="flex justify-center mb-4" data-id="element-217">
              <Clock className="h-12 w-12 text-settl-blue" data-id="element-218" />
            </div>
            <div className="font-space-mono text-4xl font-bold text-charcoal mb-2" data-id="element-219">
              12+
            </div>
            <p className="text-slate-grey" data-id="element-220">
              Hours spent monthly on manual bill processing
            </p>
          </div>
          {/* Statistic 2 */}
          <div className="card text-center" data-id="element-221">
            <div className="flex justify-center mb-4" data-id="element-222">
              <CreditCard className="h-12 w-12 text-settl-blue" data-id="element-223" />
            </div>
            <div className="font-space-mono text-4xl font-bold text-charcoal mb-2" data-id="element-224">
              15-50
            </div>
            <p className="text-slate-grey" data-id="element-225">
              Average monthly bills for growing SMEs
            </p>
          </div>
          {/* Statistic 3 */}
          <div className="card text-center" data-id="element-226">
            <div className="flex justify-center mb-4" data-id="element-227">
              <TrendingDown className="h-12 w-12 text-settl-blue" data-id="element-228" />
            </div>
            <div className="font-space-mono text-4xl font-bold text-charcoal mb-2" data-id="element-229">
              RM 3,500
            </div>
            <p className="text-slate-grey" data-id="element-230">
              Average monthly late fees paid by SMEs
            </p>
          </div>
          {/* Statistic 4 */}
          <div className="card text-center" data-id="element-231">
            <div className="flex justify-center mb-4" data-id="element-232">
              <AlertCircle className="h-12 w-12 text-settl-blue" data-id="element-233" />
            </div>
            <div className="font-space-mono text-4xl font-bold text-charcoal mb-2" data-id="element-234">
              23%
            </div>
            <p className="text-slate-grey" data-id="element-235">
              Of bills have errors or duplicate payments
            </p>
          </div>
        </div>
        <div className="bg-white rounded-xl p-8 shadow-sm max-w-4xl mx-auto" data-id="element-236">
          <h3 className="font-outfit font-semibold text-2xl mb-4 text-center" data-id="element-237">
            The Real Cost Goes Beyond Money
          </h3>
          <div className="space-y-4" data-id="element-238">
            <p className="text-slate-grey" data-id="element-239">
              <span className="font-medium text-charcoal" data-id="element-240">⏱️ Time drain:</span>{' '}
              Your finance team spends hours processing invoices, reconciling
              accounts, and chasing approvals.
            </p>
            <p className="text-slate-grey" data-id="element-241">
              <span className="font-medium text-charcoal" data-id="element-242">
                💸 Cash flow constraints:
              </span>{' '}
              Paying everything immediately ties up capital that could be better
              used elsewhere.
            </p>
            <p className="text-slate-grey" data-id="element-243">
              <span className="font-medium text-charcoal" data-id="element-244">🔍 Error-prone:</span>{' '}
              Manual processes lead to mistakes, duplicate payments, and missed
              invoices.
            </p>
            <p className="text-slate-grey" data-id="element-245">
              <span className="font-medium text-charcoal" data-id="element-246">😓 Stress:</span>{' '}
              Constantly juggling payment deadlines creates unnecessary pressure
              on your team.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default ProblemSection;